"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Table = _interopRequireDefault(require("react-bootstrap/Table"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Tables = props => {
  let headers, tableBody;
  let indexes = props.index;
  if (props.head) {
    headers = props.head.map((ele, index) => {
      // setting Colspan on header need to pass the colspan and index on which it should be applied
      // index={[{ 0: 1 }, { 1: 3 }]} Format to pass colspan apart from head and body pass index as shown
      if (indexes) {
        let keys;
        let values;
        if (indexes[index] != undefined) {
          keys = Object.keys(indexes[index]);
          values = Object.values(indexes[index]);
        }
        if (index == keys) {
          return /*#__PURE__*/_react.default.createElement("th", {
            colSpan: values,
            key: keys
          }, (0, _htmlReactParser.default)(ele));
        }
      } else {
        return /*#__PURE__*/_react.default.createElement("th", _extends({
          key: index,
          onClick: e => props.click1(e)
        }, props), " ", (0, _htmlReactParser.default)(ele));
      }
    });
  }

  // Mapping the body dynamically based on keys passed

  //  All table rows must have the same keys as seen in the props passed from homepage
  if (props.body) {
    tableBody = props.body.map((ele, index) => {
      let keys = Object.keys(ele);
      let bodyData = keys.map((elem, i) => {
        let date = new Date(ele[elem]);
        if (date == 'Invalid Date') {
          return /*#__PURE__*/_react.default.createElement("td", {
            key: i
          }, ele[elem] !== '' ? ele[elem] !== 'NULL' ? (0, _htmlReactParser.default)(ele[elem]) : "--" : '--');
        } else {
          return /*#__PURE__*/_react.default.createElement("td", {
            key: i
          }, date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear(), " ");
        }
      });
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: ele + index
      }, bodyData);
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Table.default, _extends({
    responsive: true,
    bordered: true,
    hover: true
  }, props), /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, headers)), /*#__PURE__*/_react.default.createElement("tbody", null, tableBody), props.children);
};
var _default = exports.default = Tables;